<template>
    <div v-if="language.includes('es')">
        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1> Asesores </h1>  
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FBrigitte.jpg?alt=media&token=ecfb206c-a5ee-40c3-8e63-b9ac8ff88f2b">
            </div>
            <div class="advisor-name">
                <h2>Jaddy Brigitte Nielsen Nino, Ph.D</h2>
                <h3>COORDINADORA</h3>
                <p>Confiada y fiable en sus habilidades para liderar equipos e inspirar a otros, con habilidades destacadas en dirección y pensamiento crítico. Competente en tecnología, codificación, idiomas y enseñanza. Habla español, inglés y neerlandés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FJuan.jpg?alt=media&token=67dc0231-e82f-4cf0-b5a8-1f57caa6a681">
            </div>
            <div class="advisor-name">
                <h2>Juan Camilo Ávila Laverde</h2>
                <h3>DESARROLLADOR</h3>
                <p>Dedicado y fuerte solucionador de problemas, con habilidades destacadas en la gestión del tiempo de desarrollo. Competente en codificación, programación y frameworks, estudia Ingeniería de Software. Habla español e inglés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Andrés Florez</h2>
                <h3>DESARROLLADOR DE SOFTWARE</h3>
                <p>Muestra entusiasmo por el trabajo realizado y le encanta aprender cosas nuevas y aplicar tácticas o ideas novedosas en nuestros proyectos. Disfruta mucho formando parte de este proyecto. Habla español.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Santiago Sánchez Arellano</h2>
                <h3>DISEÑADOR GRÁFICO</h3>
                <p>Dedica tiempo y esfuerzo a asegurarse de que contribuye al máximo a nuestros proyectos. Es una persona con excelentes dotes de comunicación. Sabe escuchar y responder a las preguntas con respuestas concisas y bien elaboradas. Habla español e inglés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Deimer Velasco Diaz</h2>
                <h3>DISEÑADOR WEB</h3>
                <p>Cree en sus capacidades. Además, se siente seguro formando parte de este proyecto, lo que nos ahorra tiempo y energía al equipo directivo. Habla español e inglés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Daniela Camargo Ovalle</h2>
                <h3>ILUSTRADORA</h3>
                <p>Es una colaboradora de equipo que impulsa el éxito del proyecto, además de dar y recibir feedback constructivo. Habla español e inglés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Angelica Garcia</h2>
                <h3>EDUCADORA MULTICULTURAL</h3>
                <p>Ella tiene la capacidad de planificar y controlar cómo gastar su tiempo para lograr eficazmente nuestros objetivos como equipo. Es capaz de encontrar motivación sin depender de factores externos. Habla español.</p>
            </div>
        </div>
    </div>
    <div v-else>
        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1> Advisors </h1>  
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FBrigitte.jpg?alt=media&token=ecfb206c-a5ee-40c3-8e63-b9ac8ff88f2b">
            </div>
            <div class="advisor-name">
                <h2>Jaddy Brigitte Nielsen Nino, Ph.D</h2>
                <h3>COORDINATOR</h3>
                <p>Reliable and confidence in her abilities to lead teams and inspire others, with distinguished directing and critical thinking skills. Competent at technology, coding, languages and teaching. She speaks Spanish, English and Dutch.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FJuan.jpg?alt=media&token=67dc0231-e82f-4cf0-b5a8-1f57caa6a681">
            </div>
            <div class="advisor-name">
                <h2>Juan Camilo Ávila Laverde</h2>
                <h3>DEVELOPER</h3>
                <p>Dedicated and strong problem solver, with distinguished developing time-managenent skills. Competent at coding, programming and frameworks, studies Software Engineer. He speaks Spanish and English.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Andrés Florez</h2>
                <h3>SOFTWARE DEVELOPER</h3>
                <p>He shows enthusiasm for the work he has done delight in learning new things and applying novel tactics or ideas in our projects. He really enjoys to be part of this project. He speaks Spanish.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Santiago Sánchez Arellano</h2>
                <h3>GRAPHIC DESIGNER</h3>
                <p>He puts in the time and effort to ensure he’s contributing as much as he can to our projects. He is a person who possesses excellent communication skills. He is a good listener, and can field questions with concise, well-constructed responses. He speaks Spanish and English.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Deimer Velasco Diaz</h2>
                <h3>WEB DESIGNER</h3>
                <p>He believes in his abilities. Additionally, he feels confident being part of this project which saves us management team time and energy. He speaks Spanish and English.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Daniela Camargo Ovalle</h2>
                <h3>ILUSTRATOR</h3>
                <p>She is a team collaborator that drives success the project, as well as giving and receiving constructive feedback. She speaks Spanish and English.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="">
            </div>
            <div class="advisor-name">
                <h2>Angelica Garcia</h2>
                <h3>MULTICULTURAL EDUCATOR</h3>
                <p>She has the ability to plan and control how she spends their time to effectively accomplish our goals as a team. She is able to find motivation without relying on outside factors. She speaks Spanish.</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name : 'advisors',
    data () {
        return {
            language: navigator.language
        }
    },
    mounted () {
        if (this.language.includes('es')) {
            document.title = 'Asesores'
        } else {
            document.title = 'Advisors'
        }
    }
}

</script>

<style src="@/assets/css/footer/advisors.css" scoped></style>
